import { render, staticRenderFns } from "./MdrtbRegiment.vue?vue&type=template&id=65302e15"
import script from "./MdrtbRegiment.vue?vue&type=script&lang=js"
export * from "./MdrtbRegiment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports